import { Divider } from "@mui/material";
import { useTheme } from "../../../components/hooks/useTheme";
import { useEffect, useState } from "react";
import { bookingsStatusColorCode } from "../../../utils/statusColorCode";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import SecuityDeposit from "./SecuityDeposit2";
import moment from "moment";
import useGeneral from "../../../components/hooks/useGeneral";


type SummaryProps = {
  summaryData: any;
  reservationId: number;
  showDateAndTimeBox: () => void;
  selectedVehicleClass: any;
  appliedDiscountList: any[];
  securityDepositAmount: number;
  updateSecurityDepositAmountToPaid: (updateAmount: number) => void;
  setWasSecurityDepositManuallyChanged: (value: boolean) => void;
  refreshTheSummary: () => void;
  setPleaseWaitPopup: (value: boolean) => void;
};

export const SummaryWithReservation = ({
  reservationId,
  summaryData,
  showDateAndTimeBox,
  selectedVehicleClass,
  appliedDiscountList,
  securityDepositAmount,
  updateSecurityDepositAmountToPaid,
  setWasSecurityDepositManuallyChanged,
  refreshTheSummary,
  setPleaseWaitPopup
}: SummaryProps) => {
  const { themeStyles } = useTheme();
  const { dateFormat }: any = useGeneral();
  const [statusBg, setStatusBg] = useState<string>("");
  const [statusTextColor, setStatusTextColor] = useState<string>("");
  const navigate = useNavigate();

  const [openSecurityDepositDialog, setOpenSecurityDepositDialog] = useState<boolean>(false);

  useEffect(() => {
    let color = {
      colorBg: "#000000",
      colorText: "#000000"
    };

    color = bookingsStatusColorCode?.find((color: any) => color?.label === summaryData?.status.trim()?.toLowerCase()) || {
      colorBg: "#000000",
      colorText: "#000000"
    };

    setStatusBg(color.colorBg);
    setStatusTextColor(color.colorText);
  }, [summaryData])

  return (
    <>
      <div className={`w-full bg-transparent p-2 flex flex-col gap-1.5 rounded-lg shadow-sm border mt-4 ${themeStyles.main.borderColor}`}>
        <div className={`flex justify-between items-center py-4 border-b ${themeStyles.main.borderColor}`}>
          <span className={`text-sm font-bold ${themeStyles.main.textHeadingColor}`}>Summary</span>

          <span className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold ${statusBg} ${statusTextColor} border ${themeStyles.main.borderColor}`}>
            {summaryData?.status}
          </span>

        </div>

        <div className="flex flex-col gap-1.5 py-2">
          <div className="flex flex-col justify-between items-start mb-4">
            <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textSubHeadingColor}`}>Branch</span>
            <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textHeadingColor}`}>{summaryData?.branchName}</span>
          </div>

          {
            summaryData?.vehicleReplacedReturnDates
              ?.map((item: any, index: number, arr: any[]) => (
                <div
                  key={index}
                  className={`flex flex-col justify-between items-start ${index === arr.length - 1 ? "mb-4" : ""}`}
                >
                  <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textSubHeadingColor}`}>Replaced Date {index + 1}</span>
                  <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textHeadingColor}`}>
                    {item &&
                      format(
                        new Date(item),
                        "EEEE, MMMM dd, yyyy @ hh:mm a"
                      )
                    }
                  </span>
                </div>
              ))
          }

          {
            summaryData?.dateTimeCheckOut && (
              <div className="flex flex-col justify-between items-start">
                <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textSubHeadingColor}`}>Pickup Date</span>
                <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textHeadingColor}`}>
                  {
                    summaryData?.vehicleReplacedPickupDates?.length > 0
                      ? format(
                        new Date(summaryData?.vehicleReplacedPickupDates[0]),
                        "EEEE, MMMM dd, yyyy @ hh:mm a"
                      )
                      :
                      format(
                        new Date(summaryData?.dateTimeCheckOut),
                        "EEEE, MMMM dd, yyyy @ hh:mm a"
                      )
                  }
                </span>
              </div>
            )
          }

          <div className="flex flex-col justify-between items-start">
            <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textSubHeadingColor}`}>Initial Pickup Date
              {
                (summaryData?.status === 'Open') && (
                  <span
                    className={`material-symbols-outlined ml-1 text-[14px] cursor-pointer font-light text-[#0000ff]`}
                    onClick={() => showDateAndTimeBox()}
                  >
                    edit
                  </span>
                )
              }

            </span>
            <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textHeadingColor}`}>{format(summaryData?.pickupDate, "EEEE, MMMM dd, yyyy @ hh:mm a")}</span>
          </div>

          <div className="flex flex-col justify-between items-start mb-4">
            <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textSubHeadingColor}`}>Pickup Location</span>
            <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textHeadingColor}`}>{summaryData?.pickupLocationName}</span>
          </div>

          {
            summaryData?.dateTimeCheckIn && (
              <div className="flex flex-col justify-between items-start">
                <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textSubHeadingColor}`}>Return Date</span>
                <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textHeadingColor}`}>
                  {
                    format(
                      new Date(summaryData?.dateTimeCheckIn),
                      "EEEE, MMMM dd, yyyy @ hh:mm a"
                    )
                  }
                </span>
              </div>
            )
          }

          <div className="flex flex-col justify-between items-start">
            <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textSubHeadingColor}`}>Initial Return Date
              {
                (
                  summaryData?.status === 'Open') && (
                  <span
                    className={`material-symbols-outlined ml-1 text-[14px] cursor-pointer font-light text-[#0000ff]`}
                    onClick={() => showDateAndTimeBox()}
                  >
                    edit
                  </span>
                )
              }
            </span>
            <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textHeadingColor}`}>{format(summaryData?.returnDate, "EEEE, MMMM dd, yyyy @ hh:mm a")}</span>
          </div>

          <div className="flex flex-col justify-between items-start mb-4">
            <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textSubHeadingColor}`}>Return Location</span>
            <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textHeadingColor}`}>{summaryData?.returnLocationName}</span>
          </div>

          {
            (summaryData?.status === "Cancelled" || summaryData?.status === "Cancelled Paid") && (
              <>
                <div className="flex flex-col justify-between items-start mb-2">
                  <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textSubHeadingColor}`}>Cancellation Date</span>
                  <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textHeadingColor}`}>
                    {
                      summaryData?.cancellationDate ? format(new Date(summaryData?.cancellationDate), "EEEE, MMMM dd, yyyy") : ""
                    }
                  </span>
                </div>

                <div className="flex flex-col justify-between items-start mb-2">
                  <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textSubHeadingColor}`}>Cancellation Comments</span>
                  <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textHeadingColor}`}>{summaryData?.cancellationReason}</span>
                </div>

                <div className="flex flex-col justify-between items-start mb-4">
                  <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textSubHeadingColor}`}>Cancelled By</span>
                  <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textHeadingColor}`}>{summaryData?.cancelledBy}</span>
                </div>
              </>
            )
          }

          {
            (
              summaryData?.vehicleId > 0) && (
              <div className="flex flex-col justify-between items-start mb-4">
                <span className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textSubHeadingColor}`}>Active Vehicle</span>
                <span
                  className={`text-xs font-medium break-all w-full text-left hover:underline text-[#0000ff] cursor-pointer`}
                  onClick={() =>
                    navigate("/fleet/vehicle/editvehicles", {
                      state: summaryData?.vehicleId,
                    })
                  }
                >
                  {summaryData?.vehicleName}
                </span>
              </div>
            )
          }

          <div className="flex flex-col mb-4">
            <span className={`text-xs font-medium break-all text-left ${themeStyles.main.textSubHeadingColor}`}>Vehicle Class</span>
            {
              summaryData?.vehicleClassLabels
                ?.map((item: any, index: number) => (
                  <span
                    key={index}
                    className={`text-xs font-medium break-all w-full text-left ${themeStyles.main.textHeadingColor}`}
                  >
                    {(index === 0 ? "" : " -> ") + item}
                  </span>
                ))
            }

            {
              (summaryData?.status === "Quotes" || summaryData?.status === "Open") &&
              <span className={`text-xs font-medium break-all w-full text-left text-red-500`}>{selectedVehicleClass?.availableVehicles < 0 ? "(Not Available)" : ""}</span>
            }
          </div>

          <div className="flex justify-between gap-x-[0.25rem]">
            <div className="flex-1 flex flex-col justify-between items-start">
              <span className={`text-xs font-medium break-all flex-1 text-left ${themeStyles.main.textSubHeadingColor}`}>Included Distance</span>
              <span className={`text-xs font-medium break-all flex-1 text-left ${themeStyles.main.textHeadingColor}`}>{`${summaryData?.includedMiles} ${summaryData?.includedMiles > 1 ? "miles" : "mile"}`}</span>
            </div>

            {
              (
                summaryData?.dateTimeCheckOut && summaryData?.dateTimeCheckIn) && (
                <div className="flex-1 flex flex-col justify-between items-start">
                  <span className={`text-xs font-medium break-all flex-1 text-left ${themeStyles.main.textSubHeadingColor}`}>Total Driven Distance</span>
                  <span className={`text-xs font-medium break-all flex-1 text-left ${themeStyles.main.textHeadingColor}`}>{`${summaryData?.totalDrivenMiles} ${summaryData?.totalDrivenMiles > 1 ? "miles" : "mile"}`}</span>
                </div>
              )
            }
          </div>
        </div>

        <>
          <Divider className={`w-full ${themeStyles.divider.bg}`} />

          <div className={`pt-2`}>
            <span className={`text-sm font-bold ${themeStyles.main.textHeadingColor}`}>Price Details</span>
          </div>

          <div className="flex flex-col gap-1.5">
            {
              summaryData?.totalMonths !== 0 && (
                <div className="flex justify-between items-start w-full">
                  <span className={`text-xs font-medium break-all flex-1 text-left ${themeStyles.main.textHeadingColor}`}>{summaryData?.totalMonths}x Months</span>
                  <span className={`text-xs font-medium break-all flex-1 text-right ${themeStyles.main.textHeadingColor}`}> ${summaryData?.monthlyRate?.toFixed(2)}</span>
                  <span className={`text-xs font-medium break-all flex-1 text-right ${themeStyles.main.textHeadingColor}`}>${(summaryData?.totalMonths * summaryData?.monthlyRate)?.toFixed(2)}</span>
                </div>
              )
            }

            {
              summaryData?.totalWeeks !== 0 && (
                <div className="flex justify-between items-start w-full">
                  <span className={`text-xs font-medium break-all flex-1 text-left ${themeStyles.main.textHeadingColor}`}>{summaryData?.totalWeeks}x Weeks</span>
                  <span className={`text-xs font-medium break-all flex-1 text-right ${themeStyles.main.textHeadingColor}`}>${summaryData?.weeklyRate?.toFixed(2)}</span>
                  <span className={`text-xs font-medium break-all flex-1 text-right ${themeStyles.main.textHeadingColor}`}>${(summaryData?.totalWeeks * summaryData?.weeklyRate)?.toFixed(2)}</span>
                </div>
              )
            }

            {
              summaryData?.totalDays !== 0 && (
                <div className="flex justify-between items-start w-full">
                  <span className={`text-xs font-medium break-all flex-1 text-left ${themeStyles.main.textHeadingColor}`}>{summaryData?.totalDays}x Days</span>
                  <span className={`text-xs font-medium break-all flex-1 text-right ${themeStyles.main.textHeadingColor}`}>${summaryData?.dailyRate?.toFixed(2)}</span>
                  <span className={`text-xs font-medium break-all flex-1 text-right ${themeStyles.main.textHeadingColor}`}>${(summaryData?.totalDays * summaryData?.dailyRate)?.toFixed(2)}</span>
                </div>
              )
            }

            {
              summaryData?.totalHours !== 0 && (
                <div className="flex justify-between items-start w-full">
                  <span className={`text-xs font-medium break-all flex-1 text-left ${themeStyles.main.textHeadingColor}`}>{summaryData?.totalHours}x Hours</span>
                  <span className={`text-xs font-medium break-all flex-1  text-right ${themeStyles.main.textHeadingColor}`}>${summaryData?.hourlyRate?.toFixed(2)}</span>
                  <span className={`text-xs font-medium break-all flex-1 text-right ${themeStyles.main.textHeadingColor}`}>${(summaryData?.totalHours * summaryData?.hourlyRate)?.toFixed(2)}</span>
                </div>
              )
            }

            <Divider className={`w-full ${themeStyles.divider.bg}`} />

            {
              appliedDiscountList
                ?.filter((item: any) => item?.discountApplied)
                ?.map((item: any, index: number) => {
                  return (
                    <div key={index} className="flex justify-between items-center">
                      <span className={`text-xs font-medium break-all flex-1 text-left ${themeStyles.main.textSubHeadingColor}`}>{item?.discountDefinition}:</span>
                      <span className={`text-xs font-medium break-all w-[30%] text-right ${themeStyles.main.textHeadingColor}`}>-${parseFloat(item?.discount)?.toFixed(2)}</span>
                    </div>
                  )
                })
            }

            {
              summaryData?.chargeFuelToClient && summaryData?.fuelLevel > 0 && (
                <div>
                  <span className={`text-sm font-bold ${themeStyles.main.textHeadingColor}`}>Equipment & Services</span>
                  <div className="flex justify-between items-start mb-2">
                    <span className={`text-xs font-medium break-all flex-1 text-left ${themeStyles.main.textSubHeadingColor}`}>Charge For Fuel {summaryData?.fuelLevel}x:</span>
                    <span className={`text-xs font-medium break-all w-[30%] text-right ${themeStyles.main.textHeadingColor}`}>${summaryData?.fuelCharge?.toFixed(2)}</span>
                  </div>
                </div>
              )
            }

            {
              summaryData?.additionalCategoryDto
                ?.map((item: any, j: number) => {
                  return (
                    <div key={j}>
                      <span className={`text-sm font-bold ${themeStyles.main.textHeadingColor}`}>{item?.categoryName}</span>

                      {
                        item?.additionalChargesDto?.map((value: any, i: number) => (
                          <div key={i} className="flex justify-between items-center mb-2">
                            <span className={`text-xs font-medium break-all flex-1 text-left ${themeStyles.main.textSubHeadingColor}`}>{value?.name} {value?.quantity > 1 ? value?.quantity + "x " : ''}:</span>
                            <span className={`text-xs font-medium break-all w-[30%] text-right ${themeStyles.main.textHeadingColor}`}>${(value?.quantity * value?.basePrice)?.toFixed(2)}</span>
                          </div>
                        ))
                      }
                    </div>
                  )
                })
            }

            {
              (
                summaryData?.mandatoryAdditionalChargesAmount > 0
                || summaryData?.locationFeePercentage > 0
                || summaryData?.taxPercentage > 0
                || summaryData?.governmentTaxPercentage > 0
              )
              && (
                <div>
                  <span className={`text-sm font-bold ${themeStyles.main.textHeadingColor}`}>Miscellaneous</span>

                  {
                    summaryData?.mandatoryAdditionalChargesAmount > 0 &&
                    (
                      <div className="flex justify-between items-center">
                        <span className={`text-xs font-medium break-all flex-1 text-left ${themeStyles.main.textSubHeadingColor}`}>{summaryData?.mandatoryAdditionalChargesName}:</span>
                        <span className={`text-xs font-medium break-all w-[30%] text-right ${themeStyles.main.textHeadingColor}`}>${parseFloat(summaryData?.mandatoryAdditionalChargesAmount)?.toFixed(2)}</span>
                      </div>
                    )
                  }

                  {
                    summaryData?.locationFeePercentage > 0 &&
                    (
                      <div className="flex justify-between items-center">
                        <span className={`text-xs font-medium break-all flex-1 text-left ${themeStyles.main.textSubHeadingColor}`}>{`${summaryData?.locationFeeName} (${summaryData?.locationFeePercentage}%)`}:</span>
                        <span className={`text-xs font-medium break-all w-[30%] text-right ${themeStyles.main.textHeadingColor}`}>${parseFloat(summaryData?.locationFeeAmount)?.toFixed(2)}</span>
                      </div>
                    )
                  }

                  {
                    summaryData?.taxPercentage > 0 &&
                    (
                      <div className="flex justify-between items-center">
                        <span className={`text-xs font-medium break-all flex-1 text-left ${themeStyles.main.textSubHeadingColor}`}>{`${summaryData?.taxName} (${summaryData?.taxPercentage}%)`}:</span>
                        <span className={`text-xs font-medium break-all w-[30%] text-right ${themeStyles.main.textHeadingColor}`}>${parseFloat(summaryData?.taxAmount)?.toFixed(2)}</span>
                      </div>
                    )
                  }

                  {
                    summaryData?.governmentTaxPercentage > 0 &&
                    (
                      <div className="flex justify-between items-center">
                        <span className={`text-xs font-medium break-all flex-1 text-left ${themeStyles.main.textSubHeadingColor}`}>{`${summaryData?.governmentTaxName} (${summaryData?.governmentTaxPercentage}%)`}:</span>
                        <span className={`text-xs font-medium break-all w-[30%] text-right ${themeStyles.main.textHeadingColor}`}>${parseFloat(summaryData?.governmentTaxAmount)?.toFixed(2)}</span>
                      </div>
                    )
                  }
                </div>
              )
            }
          </div>

          <Divider className={`w-full !mt-2 ${themeStyles.divider.bg}`} />

          <div className={`flex justify-between items-center py-2`}>
            <span className={`text-sm font-bold ${themeStyles.main.textSubHeadingColor}`}>Total</span>
            <span className={`text-sm font-bold ${themeStyles.main.textHeadingColor}`}>${summaryData?.totalPrice?.toFixed(2)}</span>
          </div>

          {
            (!summaryData?.securityDepositPaid
              && (summaryData?.status === 'Open' || summaryData?.status === 'Quotes')) && (
              <>
                <Divider className={`w-full ${themeStyles.divider.bg}`} />

                <div className={`flex justify-between items-center py-4`}>
                  <span className={`text-sm font-bold ${themeStyles.main.textSubHeadingColor}`}>Security Deposit
                    {
                      <span
                        className={`material-symbols-outlined ml-1 text-[14px] cursor-pointer font-light text-[#0000ff]`}
                        onClick={() => setOpenSecurityDepositDialog(true)}
                      >
                        edit
                      </span>
                    }
                  </span>

                  <span className={`text-sm font-bold ${!summaryData?.securityDepositPaid ? "text-red-500" : themeStyles.main.textHeadingColor}`}>${securityDepositAmount ? securityDepositAmount?.toFixed(2) : 0.00}</span>
                </div>
              </>
            )
          }

          {
            summaryData?.rentalReservationPayments
              ?.filter((item: any) => item?.paymentType === "Payment")
              ?.length > 0 && (
              <>
                <Divider className={`w-full ${themeStyles.divider.bg}`} />

                <div className={`pt-2`}>
                  <span className={`text-sm font-bold ${themeStyles.main.textHeadingColor}`}>Payments</span>
                </div>

                <div className="flex flex-col">
                  {
                    summaryData?.rentalReservationPayments
                      ?.filter((item: any) => item?.paymentType === "Payment")
                      ?.map((item: any, index: number) => {
                        let subHeaderTest = "";

                        if (item?.cClastFourDigit) {
                          subHeaderTest = `${item?.cClastFourDigit || ""} ${item?.brand} - ${item?.reference || ""}`;
                        } else if (item?.brand) {
                          subHeaderTest = `${item?.brand || ""} - ${item?.reference || ""}`;
                        } else {
                          subHeaderTest = `${item?.reference || ""}`;
                        }


                        return (
                          <div key={index} className="flex justify-between items-center">
                            <span className={`text-xs font-medium break-all flex-1 text-left ${themeStyles.main.textSubHeadingColor}`}>{subHeaderTest}:</span>
                            <span className={`text-xs font-medium break-all w-[30%] text-right ${themeStyles.main.textHeadingColor}`}>${parseFloat(item?.amount)?.toFixed(2)}</span>
                          </div>
                        )
                      })
                  }
                </div>
              </>
            )
          }

          {
            summaryData?.rentalReservationPayments
              ?.filter((item: any) => item?.paymentType === "Security Deposit")
              ?.length > 0 && (
              <>
                <Divider className={`w-full ${themeStyles.divider.bg}`} />

                <div className={`pt-2`}>
                  <span className={`text-sm font-bold ${themeStyles.main.textHeadingColor}`}>Security Deposits</span>
                </div>

                <div className="flex flex-col">
                  {
                    summaryData?.rentalReservationPayments
                      ?.filter((item: any) => item?.paymentType === "Security Deposit")
                      ?.map((item: any, index: number) => {
                        let subHeaderTest = "";

                        if (item?.cClastFourDigit) {
                          subHeaderTest = `${item?.cClastFourDigit || ""} ${item?.brand} - ${item?.reference || ""} (Security Deposit)`;
                        } else if (item?.brand) {
                          subHeaderTest = `${item?.brand || ""} - ${item?.reference || ""} (Security Deposit)`;
                        } else {
                          subHeaderTest = `${item?.reference || ""} (Security Deposit)`;
                        }

                        return (
                          <div key={index} className="flex justify-between items-center mb-2">
                            <span className={`text-xs font-medium break-all flex-1 text-left ${themeStyles.main.textSubHeadingColor}`}>{subHeaderTest}:</span>
                            <span className={`text-xs font-medium break-all w-[30%] text-right ${themeStyles.main.textHeadingColor}`}>${parseFloat(item?.amount)?.toFixed(2)}</span>
                          </div>
                        )
                      })
                  }
                </div>
              </>
            )
          }

          {
            summaryData?.rentalReservationRefunds?.length > 0 && (
              <>
                <Divider className={`w-full ${themeStyles.divider.bg}`} />

                <div className={`pt-2`}>
                  <span className={`text-sm font-bold ${themeStyles.main.textHeadingColor}`}>Refunds</span>
                </div>

                <div className="flex flex-col">
                  {
                    summaryData?.rentalReservationRefunds?.map((item: any, index: number) => {
                      const isSecurityDepositRefund = item?.refundType === "Security Deposit";
                      let subHeaderTest = "";

                      if (item?.cClastFourDigit) {
                        subHeaderTest = `${item?.cClastFourDigit || ""} ${item?.brand || ""} - ${item?.reference || ""} ${isSecurityDepositRefund ? "(Security Deposit)" : ""}`;
                      } else if (item?.brand) {
                        subHeaderTest = `${item?.brand || ""} - ${item?.reference || ""} ${isSecurityDepositRefund ? "(Security Deposit)" : ""}`;
                      } else {
                        subHeaderTest = `${item?.reference || ""} ${isSecurityDepositRefund ? "(Security Deposit)" : ""}`;
                      }

                      return (
                        <div key={index} className="flex justify-between items-center mb-2">
                          <span className={`text-xs font-medium break-all flex-1 text-left ${themeStyles.main.textSubHeadingColor}`}>{subHeaderTest}:</span>
                          <span className={`text-xs font-medium break-all w-[30%] text-right ${themeStyles.main.textHeadingColor}`}>${Math.abs(parseFloat(item?.amount))?.toFixed(2)}</span>
                        </div>
                      )
                    })
                  }
                </div>
              </>
            )
          }

          <>
            <Divider className={`w-full ${themeStyles.divider.bg}`} />

            <div className={`flex justify-between items-center py-2`}>
              <span className={`text-sm font-bold ${themeStyles.main.textSubHeadingColor}`}> Outstanding Balance</span>

              <span className={`text-sm font-bold ${themeStyles.main.textHeadingColor}`}>${summaryData?.outstandingBalance?.toFixed(2) ?? 0.00}</span>
            </div>
          </>

          {
            (summaryData?.status === "Cancelled" || summaryData?.status === "Cancelled Paid") && (
              <>
                <Divider className={`w-full ${themeStyles.divider.bg}`} />

                <div className={`flex justify-between items-center py-2`}>
                  <span className={`text-sm font-bold ${themeStyles.main.textSubHeadingColor}`}>Cancellation Fee</span>

                  <span className={`text-sm font-bold ${themeStyles.main.textHeadingColor}`}>${Number(summaryData?.cancellationFee)?.toFixed(2) ?? 0.00}</span>
                </div>
              </>
            )
          }

          {
            summaryData && (
              <>
                <Divider className={`w-full ${themeStyles.divider.bg}`} />

                <div className={`pt-2`}>
                  <span className={`text-sm font-bold ${themeStyles.main.textHeadingColor}`}>Audits</span>
                </div>

                <div className="flex flex-col gap-1.5">
                  <div className="flex  justify-between items-start">
                    <span className={`text-xs font-medium break-all w-[30%] text-left ${themeStyles.main.textSubHeadingColor}`}>Created By</span>
                    <span className={`text-xs font-medium break-all flex-1 text-right ${themeStyles.main.textHeadingColor}`}>{summaryData?.createdBy}</span>
                  </div>

                  <div className="flex justify-between items-start mb-2">
                    <span className={`text-xs font-medium break-all w-[30%] text-left ${themeStyles.main.textSubHeadingColor}`}>Created At</span>
                    <span className={`text-xs font-medium break-all flex-1 text-right ${themeStyles.main.textHeadingColor}`}>
                      {
                        summaryData?.createdAt ? moment(new Date(summaryData.createdAt)).format(dateFormat + " hh:mm a") : ""
                      }
                      <br />
                    </span>
                  </div>

                  {
                    summaryData?.rentalUser && (
                      <>
                        <div className="flex justify-between items-start">
                          <span className={`text-xs font-medium break-all w-[30%] text-left ${themeStyles.main.textSubHeadingColor}`}>Rental By</span>
                          <span className={`text-xs font-medium break-all flex-1 text-right ${themeStyles.main.textHeadingColor}`}>{summaryData?.rentalUser}</span>
                        </div>

                        <div className="flex justify-between items-start mb-2">
                          <span className={`text-xs font-medium break-all w-[30%] text-left ${themeStyles.main.textSubHeadingColor}`}>Rental At</span>
                          <span className={`text-xs font-medium break-all flex-1 text-right ${themeStyles.main.textHeadingColor}`}>
                            {
                              summaryData?.rentalAt ? moment(new Date(summaryData?.rentalAt)).format(dateFormat + " hh:mm a") : ""
                            }
                          </span>
                        </div>
                      </>
                    )
                  }

                  {
                    summaryData?.completedBy && (
                      <>
                        <div className="flex justify-between items-start">
                          <span className={`text-xs font-medium break-all w-[30%] text-left ${themeStyles.main.textSubHeadingColor}`}>Completed By</span>
                          <span className={`text-xs font-medium break-all flex-1 text-right ${themeStyles.main.textHeadingColor}`}>{summaryData?.completedBy}</span>
                        </div>

                        <div className="flex justify-between items-start mb-2">
                          <span className={`text-xs font-medium break-all w-[30%] text-left ${themeStyles.main.textSubHeadingColor}`}>Completed At</span>
                          <span className={`text-xs font-medium break-all flex-1 text-right ${themeStyles.main.textHeadingColor}`}>
                            {
                              summaryData?.completedAt ? moment(new Date(summaryData?.completedAt)).format(dateFormat + " hh:mm a") : ""
                            }
                          </span>
                        </div>
                      </>
                    )
                  }

                  {
                    summaryData?.reopenedBy && (
                      <>
                        <div className="flex justify-between items-start">
                          <span className={`text-xs font-medium break-all w-[30%] text-left ${themeStyles.main.textSubHeadingColor}`}>Reopened By</span>
                          <span className={`text-xs font-medium break-all flex-1 text-right ${themeStyles.main.textHeadingColor}`}>{summaryData?.reopenedBy}</span>
                        </div>

                        <div className="flex justify-between items-start mb-2">
                          <span className={`text-xs font-medium break-all w-[30%] text-left ${themeStyles.main.textSubHeadingColor}`}>Reopened At</span>
                          <span className={`text-xs font-medium break-all flex-1 text-right ${themeStyles.main.textHeadingColor}`}>
                            {
                              (summaryData?.reopenedAt ? moment(new Date(summaryData?.reopenedAt)).format(dateFormat + " hh:mm a") : "")
                            }
                          </span>
                        </div>
                      </>
                    )
                  }
                </div>
              </>
            )
          }
        </>
      </div>

      {
        !summaryData?.securityDepositPaid
        && (
          <SecuityDeposit
            openSecurityDepositDialog={openSecurityDepositDialog}
            setOpenSecurityDepositDialog={setOpenSecurityDepositDialog}
            reservationId={reservationId}
            securityDepositAmountToPaid={securityDepositAmount}
            updateSecurityDepositAmountToPaid={updateSecurityDepositAmountToPaid}
            setWasSecurityDepositManuallyChanged={setWasSecurityDepositManuallyChanged}
            summaryData={summaryData}
            refreshTheSummary={refreshTheSummary}
            setPleaseWaitPopup={setPleaseWaitPopup}
          />
        )
      }
    </>
  )
}